import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';
import foldStyle from './style';
import Title from './Title';
import Subtitle from './Subtitle';
import SubSubtile from './SubSubTitle';
import CustumButton from './CustumButton';

export default function FoldPage() {
	let style = foldStyle();
	let isMobile = useContext(GlobalContext).isMobile;

	function InnerContents() {
		if (isMobile) {
			return (
				<div
					className={style.landScreenTextContentContainer()}
					style={style.landScreenTextContentContainerStyle()}
				>
					<Title />
				</div>
			);
		} else {
			return (
				<div
					className={style.landScreenTextContentContainer()}
					style={style.landScreenTextContentContainerStyle()}
				>
					<Title />
					<Subtitle />
					<SubSubtile />
					<CustumButton action={buttonAction} />
				</div>
			);
		}
	}

	function OuterContents() {
		if (isMobile) {
			return (
				<div style={style.outerContentContainerStyle()}>
					<Subtitle />
					<SubSubtile />
					<CustumButton action={buttonAction} />
				</div>
			);
		} else {
			return <></>;
		}
	}

	return (
		<>
			<div style={style.foldContainerStyle()}>
				<InnerContents />
			</div>
			<OuterContents />
		</>
	);

	function buttonAction() {
		window.location.href = '/courses';
	}
}
